import { CommonPaginateResponseDTO, CommonResponseDTO } from './../../dto/api/api-response.dto';
import { ApprovalCustomerDTO, CustomerDataDTO } from './../../dto/account/customer.dto';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataCustomerService {
  constructor(private http: HttpClient) {}

  public customerData: CustomerDataDTO;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }),
  };

  getData(param: any) {
    return this.http.get<CommonPaginateResponseDTO>(environment.apiUrl + '/administration/customer', {
      params: param,
    });
  }

  customerNeedApprove(): Observable<CommonResponseDTO> {
    return this.http.get<CommonResponseDTO>(environment.apiUrl + '/administration/customer-need-approval', {
      params: {},
    });
  }

  verifiedCustomer(uuid: string, param: any) {
    return this.http.patch<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/verification/${uuid}`,
      this.httpOptions, {
        params: param,
      }
    );
  }

  addCustomer(param: any, uuid: string) {
    if (uuid) {
      return this.http.put<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/${uuid}`,
        param,
        this.httpOptions
      );
    } else {
      return this.http.post<CommonResponseDTO>(`${environment.apiUrl}/administration/customer`,
        param,
        this.httpOptions
      );
    }
  }

  addBeneficieriesByAgent(param: any): Observable<CommonResponseDTO> {
    return this.http.post<CommonResponseDTO>(
      `${environment.apiUrl}/administration/customer/beneficiary`,
      param,
      this.httpOptions
    );
  }

  getIdentityImage(uuid: string) {
    return this.http.get<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/identity/${uuid}`, {
      params: {},
    });
  }

  getIdentitySelfieImage(uuid: string) {
    return this.http.get<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/selfie/${uuid}`, {
      params: {},
    });
  }

  submitVerificationCustomer(param: any, uuid: string) {
    return this.http.patch<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/verification/${uuid}`,
        param,
        this.httpOptions
      );
  }

  getHasIdentityImage() {
    return this.http.get<CommonResponseDTO>(`${environment.apiUrl}/customer/checkIdentity`, {
      params: {},
    });
  }

  getHasIdentitySelfieImage() {
    return this.http.get<CommonResponseDTO>(`${environment.apiUrl}/customer/checkIdentitySelfie`, {
      params: {},
    });
  }

  getHasIdentitySelfieBackImage() {
    return this.http.get<CommonResponseDTO>(`${environment.apiUrl}/customer/checkIdentitySelfieBack`, {
      params: {},
    });
  }

  getCustomerDetail(uuid: string) {
    return this.http.get<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/${uuid}`, {
      params: {},
    });
  }

  approvalCustomer(uuid: string, param: ApprovalCustomerDTO) {
    return this.http.patch<CommonResponseDTO>(`${environment.apiUrl}/administration/customer/approval/${uuid}`,
        param,
        this.httpOptions
      );
  }

  getDataMinimumRate(param: any) {
    return this.http.get<CommonResponseDTO>(environment.apiUrl + '/rateminimum', {
      params: param,
    });
  }
}
